import { FC } from "react";
import { Modal } from 'antd';

interface CommonModalProps {
    open: boolean;
    onCancel: () => void;
    children: any;
    title?: string;
    centered?: boolean;
    bodyStyle?: React.CSSProperties;
    closable?: boolean;
    width?: number;
    footer?: React.ReactNode | false;
}


const CommonModalPopup: FC<CommonModalProps> = (props) => {

    const { open, children, onCancel, closable = true, width = 700, title, bodyStyle, centered = false, footer = false } = props;

    return (
        <Modal open={open} onCancel={onCancel} width={width} closable={closable} footer={footer} title={title} bodyStyle={bodyStyle} centered={centered}>
            {children}
        </Modal>
    );
}


export default CommonModalPopup;
